/* eslint-disable @typescript-eslint/typedef */
import { ModelBase } from 'store/model-base';

export class NowBillingSummaryResponse extends ModelBase {
    public static storeName: string = 'nowBillingSummary';
    public summary: NowBillingSummary[];
    public mobileSummary: NowBillingSummary;
    public internetSummary: NowBillingSummary;

    public static create<T extends ModelBase>(data: ApiResponse = {}): T {
        data.summary = data.summary || [];

        data.mobileSummary = data.summary.find((element) => element.lob === 'Mobile') || {};
        data.internetSummary = data.summary.find((element) => element.lob === 'Internet') || {};

        const toReturn: NowBillingSummaryResponse = super.create<NowBillingSummaryResponse>(data);

        return super.create<T>(toReturn);
    }
}
